import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router';

import { routes } from 'constants/routes';
import { authSignIn } from 'store/features';

export const AuthenticatedScene = (props) => {
  const authData = useSelector(authSignIn.selectors.getData);

  return authData ? <Route {...props} /> : <Redirect to={routes.signInRoute} />;
};
